<script type="text/jsx">
import {
  computedPbxBasePlans,
  computedPbxPlans,
  computedPbxTollFreePlans,
  computedPbxPhoneNumberPlans,
  PBX_SUB_TYPES,
} from '@/common/service/computers/plans/pbx';
import mixin from '@/plans/mx/shopping-cart';
import { phoneNumberStorage, tollFreeNumberStore } from '@/plans/ZOOM_PHONE/store';
import { mapGetters } from 'vuex';
import PbxMixin from '@/plans/ZONE_PRO_PLUS/mixin/pbx-mixin';
import { logger } from '@/utils/log';

export default {
  mixins: [mixin, PbxMixin],
  computed: {
    ...mapGetters(['getSelectedPlans']),
    selectedPbxPlans() {
      return computedPbxPlans(this.getSelectedPlans);
    },
    isShowRmvBtn() {
      return this.$context.is.checkoutPage;
    },
    pbxAddonPlans() {
      return this.selectedPbxPlans.filter(item => [PBX_SUB_TYPES.FEATURE, PBX_SUB_TYPES.UNLIMITED_ADDON].includes(item.sub_type));
    },
    hasPbxCart() {
      return this.filterKeys.includes('ZOOM_PHONE');
    },
  },
  methods: {
    handlerRemoveTFNumbers(plan) {
      tollFreeNumberStore.state.pickedNumberList = [];
      phoneNumberStorage.update('tollFreeNumberState', tollFreeNumberStore.state);
      this._dispatch('remove', plan);
      this.$tracking.orderSummary(
        `remove ${this.$pkg.components.addon ? 'add-on product' : 'product'} - ${this.$t(plan.planNameKey)}`,
      );
    },
    removeTFPlan(plan) {
      return (
        <zm-button
          type="link"
          aria-label={`${this.$t('billing.common.remove')} ${this.$t(plan.planNameKey)}`}
          onClick={this.handlerRemoveTFNumbers.bind(this, plan)}
        >
          {this.$t('billing.common.remove')}
        </zm-button>
      );
    },
    $renderCallingPlanContent(plan) {
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(
            this.$t(`billing.pbx.cart_name.${plan?.pbxCategory ?? ''}`),
            this.mx_price(plan),
            plan?.plan_code
          )}
          {this.mx_discount(plan.plan_code)}
          {this.mx_license(plan.cartInfo.selected_number, this.$t('billing.planform.unit.user'))}
          {this.mx_cycle(plan.billing_cycle)}
          {this.mx_edit(plan)}
        </div>
      );
    },
    $renderTollFreePlanContent(plan) {
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(
            this.$t(`billing.pbx.cart_name.${plan.category}`),
            this.mx_price(plan),
            plan?.plan_code
          )}
          {this.mx_discount(plan.plan_code)}
          {this.mx_license(plan.cartInfo.selected_number, this.$t('billing.planform.unit.number'))}
          {this.mx_cycle(plan.billing_cycle)}
          {this.mx_edit(plan)}
          {this.isShowRmvBtn && this.removeTFPlan(plan)}
        </div>
      );
    },
    $renderCallingPlan() {
      const callingPlans = this.selectedZoneProPlusCallingPlans;
      if (!callingPlans.length) return;
      return callingPlans.map((plan) => this.$renderCallingPlanContent(plan));
    },
    $renderTollFreePlan() {
      const tollFreePlans = computedPbxTollFreePlans(this.getSelectedPlans);
      if (!tollFreePlans.length) return;
      return tollFreePlans.map((plan) => this.$renderTollFreePlanContent(plan));
    },
    $renderLocalNumberPlan() {
      const phoneNumberPlans = computedPbxPhoneNumberPlans(this.getSelectedPlans);
      if (!phoneNumberPlans.length) return;
      return phoneNumberPlans.map((plan) => this.$renderTollFreePlanContent(plan));
    },
    $renderPbxBasePlan() {
      const pbxBasePlan = computedPbxBasePlans(this.getSelectedPlans)[0];
      if (!pbxBasePlan) return null;
      if (this.hasPbxCart) return null;
      return (
        <div class="pbx-cart-part">
          {this.mx_subTitle(
            this.$t('billing.pbx.calling_fee_name.pay_you_go.MC'),
            pbxBasePlan.amount,
            pbxBasePlan?.plan_code
          )}
          {this.mx_discount(pbxBasePlan.plan_code)}
          {this.mx_cycle(pbxBasePlan.billing_cycle)}
          {this.mx_edit(pbxBasePlan)}
        </div>
      );
    },
    $renderPbxAddons() {
      if (!this.pbxAddonPlans?.length) return null;
      if (this.hasPbxCart) return null;

      logger.info("render pbx addon plan in pro plus context");

      return <div class="opc-cart-item">
        { this.mx_main_title(this.$t('billing.planform.title.zoomphone')) }
        {
          this.pbxAddonPlans.map(item => (
            <div class="pbx-cart-part" key={item.plan_code}>
              {this.mx_subTitle(this.$t(`billing.pbx.plan_name.${item.category}`), this.mx_price(item), item.plan_code)}
              {this.mx_discount(item.plan_code)}
              {this.mx_license(item.cartInfo.selected_number, this.$t('billing.planform.unit.number'))}
              {this.mx_cycle(item.billing_cycle)}
              {this.mx_edit(item)}
              {this.isShowRmvBtn && this.mx_remove(item)}
            </div>
          ))
        }
      </div>;
    },

    mergePlans (planList) {
      if(!Array.isArray(planList)) {
        return [];
      }
      return planList.reduce((acc, cur) => {
        if(Array.isArray(cur)) {
          return [...acc, ...cur];
        }
      }, [])
    },

    renderMainTitle () {
      const callingPlans = this.selectedZoneProPlusCallingPlans;
      const tollFreePlans = computedPbxTollFreePlans(this.getSelectedPlans) ;
      const pbxBasePlan = this.hasPbxCart ? [] :  computedPbxBasePlans(this.getSelectedPlans);
      const plans = this.mergePlans([callingPlans, tollFreePlans, pbxBasePlan]);
      return plans.map((item, index) => {
        if(!index) {
          return  this.mx_main_title(this.$t('billing.zone_pro_plus.title'), undefined, item.parent_category)
        }
        return <div style='display: none;'>{this.mx_main_title(this.$t('billing.zone_pro_plus.title'), undefined, item.parent_category)}</div>
      })
    },

    $renderPrice() {
      return (
        <div>
          <div class="opc-cart-item">
            {this.renderMainTitle()}
            {this.$renderCallingPlan()}
            {this.$renderTollFreePlan()}
            {this.$renderLocalNumberPlan()}
            {this.$renderPbxBasePlan()}
          </div>
          {this.$renderPbxAddons()}
        </div>
      );
    },
  },
};
</script>
<style lang="scss">
.pbx-cart-part {
  margin-bottom: 10px;
}
</style>
